(function () {
  // TODO: replace with your real Lambda Function URL
  var LAMBDA_URL = "https://a4zmgui62j4hxq73lpuido3kc40fgmoe.lambda-url.us-east-1.on.aws/";

  // Must mirror TILE_USE_TO_SURFACE in lambda_function.py exactly.
  var TILE_USE_TO_SURFACE = {
    "Wall Tile": "wall",
    "Floor Tile": "floor",
    "Floor and Wall Tile": "wall_and_floor"
  };

  var MAX_DIMENSION = 1500; // keeps upload payload well under Lambda's 6MB limit
  var JPEG_QUALITY = 0.82;

  var openBtn = document.getElementById("tile-preview-open-btn");
  if (!openBtn) return; // allow_preview was false for this product -- nothing to wire up

  var modal = document.getElementById("tile-preview-modal");
  var modalContent = document.getElementById("tile-preview-modal-content");
  var fileInput = document.getElementById("tile-preview-file-input");
  var generateBtn = document.getElementById("tile-preview-generate-btn");
  var retryBtn = document.getElementById("tile-preview-retry-btn");
  var viewFullBtn = document.getElementById("tile-preview-viewfull-btn");
  var loadingEl = document.getElementById("tile-preview-loading");
  var errorEl = document.getElementById("tile-preview-error");
  var resultEl = document.getElementById("tile-preview-result");
  var resultImg = document.getElementById("tile-preview-result-img");
  var uploadStep = document.getElementById("tile-preview-step-upload");
  var surfaceStep = document.getElementById("tile-preview-step-surface");

  var tileUse = openBtn.getAttribute("data-tile-use");
  var compressedBase64 = null;
  var compressedMimeType = null;
  var resultDataUrl = null;

  function getCurrentVariantId() {
    // Trade updates the URL's ?variant= param whenever the shopper changes
    // variant selection -- this is reliable regardless of how the picker
    // itself is implemented internally.
    var fromUrl = new URLSearchParams(window.location.search).get("variant");
    if (fromUrl) return fromUrl;

    // On first page load, before any variant change, there's no URL param
    // yet -- fall back to the variant Liquid rendered the page with.
    return openBtn.getAttribute("data-default-variant-id");
  }

  function getSelectedSurface() {
    if (surfaceStep) {
      var checked = surfaceStep.querySelector('input[name="tile_preview_surface"]:checked');
      if (checked) return checked.value;
    }
    return TILE_USE_TO_SURFACE[tileUse] || "wall";
  }

  function openModal() {
    resetModalState();
    modal.hidden = false;
  }

  function closeModal() {
    modal.hidden = true;
  }

  function resetModalState() {
    uploadStep.hidden = false;
    if (surfaceStep) surfaceStep.hidden = false;
    loadingEl.hidden = true;
    errorEl.hidden = true;
    resultEl.hidden = true;
    modalContent.classList.remove("tile-preview-modal__content--result");
    fileInput.value = "";
    fileNameEl.textContent = "No file selected";
    clearBtn.hidden = true;
    generateBtn.disabled = true;
    compressedBase64 = null;
    compressedMimeType = null;
    resultDataUrl = null;
  }

  function showError(message) {
    errorEl.textContent = message;
    errorEl.hidden = false;
    loadingEl.hidden = true;
    uploadStep.hidden = false;
    if (surfaceStep) surfaceStep.hidden = false;
  }

  function compressImage(file, callback) {
    var img = new Image();
    var reader = new FileReader();
    reader.onload = function (e) {
      img.onload = function () {
        var scale = Math.min(1, MAX_DIMENSION / Math.max(img.width, img.height));
        var canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        var dataUrl = canvas.toDataURL("image/jpeg", JPEG_QUALITY);
        callback(dataUrl.split(",")[1], "jpeg");
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  openBtn.addEventListener("click", openModal);

  Array.prototype.forEach.call(document.querySelectorAll("[data-tile-preview-close]"), function (el) {
    el.addEventListener("click", closeModal);
  });

  var fileNameEl = document.getElementById("tile-preview-file-name");
  var clearBtn = document.getElementById("tile-preview-clear-btn");

  fileInput.addEventListener("change", function () {
    var file = fileInput.files[0];
    if (!file) {
      generateBtn.disabled = true;
      fileNameEl.textContent = "No file selected";
      clearBtn.hidden = true;
      return;
    }
    fileNameEl.textContent = file.name;
    clearBtn.hidden = false;
    generateBtn.disabled = true; // re-enabled once compression finishes
    compressImage(file, function (base64, mimeType) {
      compressedBase64 = base64;
      compressedMimeType = mimeType;
      generateBtn.disabled = false;
    });
  });

  clearBtn.addEventListener("click", function () {
    fileInput.value = "";
    fileNameEl.textContent = "No file selected";
    clearBtn.hidden = true;
    generateBtn.disabled = true;
    compressedBase64 = null;
    compressedMimeType = null;
  });

  generateBtn.addEventListener("click", function () {
    if (!compressedBase64) return;

    var variantId = getCurrentVariantId();
    if (!variantId) {
      showError("Could not determine the selected tile variant. Please refresh and try again.");
      return;
    }

    uploadStep.hidden = true;
    if (surfaceStep) surfaceStep.hidden = true;
    loadingEl.hidden = false;
    errorEl.hidden = true;

    fetch(LAMBDA_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        room_image_base64: compressedBase64,
        room_image_type: compressedMimeType,
        variant_id: "gid://shopify/ProductVariant/" + variantId,
        requested_surface: getSelectedSurface()
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.error || "Something went wrong generating your preview.");
          return data;
        });
      })
      .then(function (data) {
        resultDataUrl = "data:image/png;base64," + data.image_base64;
        resultImg.src = resultDataUrl;
        loadingEl.hidden = true;
        resultEl.hidden = false;
        modalContent.classList.add("tile-preview-modal__content--result");
      })
      .catch(function (err) {
        showError(err.message || "Something went wrong generating your preview.");
      });
  });

  viewFullBtn.addEventListener("click", function () {
    if (!resultDataUrl) return;
    var tab = window.open();
    if (tab) {
      tab.document.write('<img src="' + resultDataUrl + '" style="max-width:100%;display:block;margin:0 auto;">');
      tab.document.title = "Tile Preview";
    }
  });

  retryBtn.addEventListener("click", resetModalState);
})();